(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["peel-pdp-hotspots"] && !Shopify.designMode) return;
  try {
    
/* One card open at a time. A click (or tap) toggles; on a device that can
   hover, pointing at a dot opens it too, and the card stays up while the
   pointer crosses the gap onto it. Escape or a click elsewhere closes. */
(function () {
  function initHotspots(root) {
    if (!root || root.dataset.peelHotspotsReady) return;
    root.dataset.peelHotspotsReady = 'true';

    var hotspots = Array.prototype.slice.call(root.querySelectorAll('[data-peel-hotspot]'));
    if (!hotspots.length) return;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    var closeTimer = null;

    function setOpen(hotspot, open) {
      var toggle = hotspot.querySelector('[data-peel-hotspot-toggle]');
      hotspot.classList.toggle('is-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function open(hotspot) {
      clearTimeout(closeTimer);
      hotspots.forEach(function (other) { setOpen(other, other === hotspot); });
    }
    function closeAll() {
      clearTimeout(closeTimer);
      hotspots.forEach(function (hotspot) { setOpen(hotspot, false); });
    }

    hotspots.forEach(function (hotspot) {
      var toggle = hotspot.querySelector('[data-peel-hotspot-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        // With a mouse, pointing already opened the card; a click that
        // toggled would close it again. Keyboard clicks (detail 0) and
        // taps still toggle.
        if (canHover.matches && event.detail > 0) open(hotspot);
        else if (hotspot.classList.contains('is-open')) closeAll();
        else open(hotspot);
      });
      hotspot.addEventListener('mouseenter', function () {
        if (canHover.matches) open(hotspot);
      });
      hotspot.addEventListener('mouseleave', function () {
        if (!canHover.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { setOpen(hotspot, false); }, 200);
      });
      hotspot.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !hotspot.classList.contains('is-open')) return;
        closeAll();
        toggle.focus();
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest || !event.target.closest('[data-peel-hotspot-card]')) closeAll();
    });

    // Selecting a hotspot block in the theme editor shows its card.
    root.addEventListener('shopify:block:select', function (event) {
      var hotspot = event.target.closest && event.target.closest('[data-peel-hotspot]');
      if (hotspot) open(hotspot);
    });
    root.addEventListener('shopify:block:deselect', closeAll);
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-peel-hotspots]'), initHotspots);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
